import React from 'react';
import ReactDOM from 'react-dom/client';
// Self-hosted variable fonts. Bundling these means the site renders correctly
// on networks that block fonts.googleapis.com / gstatic.com (school filters,
// guest Wi-Fi, etc.) instead of falling back to system sans.
import '@fontsource-variable/lexend';
import '@fontsource-variable/jetbrains-mono';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);